<template>
    <main ref="messagesContainer"
        class="flex-1 overflow-y-auto p-3 sm:p-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
        @scroll="handleScroll">
        <div v-if="loadingOlderMessages" class="text-center text-gray-500 py-3">
            <font-awesome-icon icon="fa-spinner" class="animate-spin mr-2" />
            Carregando mensagens antigas...
        </div>

        <div v-if="loadingMessages" class="text-center text-gray-500">
            Carregando mensagens...
        </div>

        <template v-else>
            <template v-for="(message, index) in messages" :key="message.id">
                <!-- Separador de Data -->
                <div v-if="shouldShowDateSeparator(message, index)" class="flex items-center justify-center my-4">
                    <div class="flex-grow border-t border-gray-300"></div>
                    <span class="mx-4 text-xs sm:text-sm text-gray-500 font-medium whitespace-nowrap">
                        {{ formatDateSeparator(message.created_at) }}
                    </span>
                    <div class="flex-grow border-t border-gray-300"></div>
                </div>

                <!-- Mensagem -->
                <chat-message :message="message" :is-mine="message.is_mine" />
            </template>
        </template>
    </main>
</template>

<script>
import { ref } from 'vue'
import ChatMessage from './ChatMessage.vue'

export default {
    components: {
        ChatMessage
    },

    props: {
        messages: {
            type: Array,
            default: () => []
        },
        loadingMessages: {
            type: Boolean,
            default: false
        },
        loadingOlderMessages: {
            type: Boolean,
            default: false
        },
        hasMoreMessages: {
            type: Boolean,
            default: false
        }
    },

    emits: ['load-older'],

    setup(props, { emit }) {
        const messagesContainer = ref(null)

        const handleScroll = (event) => {
            const container = event.target
            const scrollTop = container.scrollTop

            if (scrollTop < 100 && props.hasMoreMessages && !props.loadingOlderMessages && !props.loadingMessages) {
                emit('load-older')
            }
        }

        const shouldShowDateSeparator = (message, index) => {
            if (index === 0) return true

            const currentDate = new Date(message.created_at)
            const previousMessage = props.messages[index - 1]
            const previousDate = new Date(previousMessage.created_at)

            currentDate.setHours(0, 0, 0, 0)
            previousDate.setHours(0, 0, 0, 0)

            return currentDate.getTime() !== previousDate.getTime()
        }

        const formatDateSeparator = (date) => {
            if (!date) return ''

            const d = new Date(date)
            const today = new Date()
            const yesterday = new Date(today)
            yesterday.setDate(yesterday.getDate() - 1)

            today.setHours(0, 0, 0, 0)
            yesterday.setHours(0, 0, 0, 0)
            const messageDate = new Date(d)
            messageDate.setHours(0, 0, 0, 0)

            if (messageDate.getTime() === today.getTime()) {
                return 'Hoje'
            } else if (messageDate.getTime() === yesterday.getTime()) {
                return 'Ontem'
            } else {
                return d.toLocaleDateString('pt-BR', {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                })
            }
        }

        const scrollToBottom = () => {
            if (messagesContainer.value) {
                messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
            }
        }

        return {
            messagesContainer,
            handleScroll,
            shouldShowDateSeparator,
            formatDateSeparator,
            scrollToBottom
        }
    }
}
</script>
